import axios from 'axios';

export const personApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/person`,
    headers: {
        'Content-Type': 'application/json'
    }
})